import { FunctionComponent, ReactNode } from 'react'
import loginStyles from './styles'
import Icon from '@/components/HeroIcons'
import { Text, getTheme } from '@conexasaude/conexa-hero'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import TimeZoneLuxon from '../TimeZoneLuxon'

type PageLayoutProps = {
  customFooter?: ReactNode
}

const PageLayout: FunctionComponent<PageLayoutProps> = props => {
  const { children, customFooter } = props
  const styles = loginStyles()
  const theme = getTheme()

  return (
    <HeroWrapper>
      <div css={styles.containerIcon}>
        <div css={styles.containerBackground}>
          <div css={styles.backgroundContainer}>
            <div css={styles.backgroundNoise} />
            <Icon
              name="character-media-player"
              css={styles.backgroundContainerIcon}
              width={'560px'}
            />
            <Text
              variant="headingXLarge"
              color={theme.colors.background.white}
              css={styles.backgroundContainerTitle}
            >
              Olá, nós somos a Conexa Saúde
            </Text>
            <Text
              variant="headingMedium"
              color={theme.colors.background.white}
              css={styles.backgroundContainerSubtitle}
            >
              Seu novo jeito de cuidar da saúde
            </Text>
          </div>
        </div>
        <div css={styles.container}>
          <div css={styles.content}>{children}</div>
          <div css={styles.footer}>
            {customFooter ?? null}
            <TimeZoneLuxon />
            <Text
              renderAs="span"
              variant="microCopy"
              color={theme.colors.neutral[200]}
            >
              © 2021 Conexa Saúde · Todos os direitos reservados.
            </Text>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default PageLayout
